import BuilderTimeWindow from '../../BuilderTimeWindow';
import {
  ICohortRow,
  IRowMeta,
  setCohortRowLookForwardWindow,
} from '../../../../../../redux/slices/oldBuilder';
import CohortRowAnalysisMenu from '../../CohortRowAnalysisMenu';
import { QueryType } from '../../../../../../utils/apollo/graphqlSchema';
import { CohortRowContent, CohortRowRelatedInfo } from '../../CohortRowUI';
import { MAX_TIME_WINDOW } from '../../../../../../config/constants';
import BuilderNumberInputField from '../../../../BuilderFields/BuilderNumberInputField';
import { useAppDispatch } from '../../../../../../redux/hooks';
import {
  BuilderFieldContainer,
  BuilderFieldLabel,
} from '../../../../BuilderUI';
import { formatTimeUnit } from '../../../../../../utils';
import { isFunnelLookForwardWindowInputRequired } from '../../../../../../redux/slices/oldBuilder/utils';
import FunnelCohortOperators from './FunnelCohortOperators';
import FunnelCohortStepMenu from './FunnelCohortStepMenu';
import { isNil } from 'lodash';
import TimeToConvertInput from './TimeToConvertCohort/TimeToConvertCohort';
import { useCohortRowContext } from '../../CohortRowContext';

interface IProps {
  rowMeta: IRowMeta;
  cohortRow: ICohortRow;
}

const FunnelCohort = ({ rowMeta, cohortRow }: IProps) => {
  const { isTimeToConvertRow } = useCohortRowContext();
  const { lookForwardWindow, datePicker } = cohortRow;
  const dispatch = useAppDispatch();

  return (
    <CohortRowContent>
      <CohortRowRelatedInfo>
        <CohortRowAnalysisMenu
          rowMeta={rowMeta}
          cohortRow={cohortRow}
          title={'Funnel'}
          queryType={QueryType.Funnel}
        />
        {!isTimeToConvertRow && <FunnelCohortOperators />}
        <FunnelCohortStepMenu />
        {isTimeToConvertRow && <TimeToConvertInput />}
      </CohortRowRelatedInfo>
      {isFunnelLookForwardWindowInputRequired(
        lookForwardWindow,
        !isNil(datePicker),
      ) && (
        <>
          <BuilderFieldContainer>
            <BuilderFieldLabel>
              through {formatTimeUnit(lookForwardWindow.unit)}
            </BuilderFieldLabel>
            <BuilderNumberInputField
              placeholder="eg. 5"
              value={lookForwardWindow.windowLength ?? null}
              max={MAX_TIME_WINDOW}
              rowMeta={rowMeta}
              onChange={(windowLength) => {
                dispatch(
                  setCohortRowLookForwardWindow({ rowMeta, windowLength }),
                );
              }}
              errorKey="lookForwardWindow"
            />
          </BuilderFieldContainer>
        </>
      )}
      <BuilderTimeWindow />
    </CohortRowContent>
  );
};

export default FunnelCohort;
